import { useState, useEffect } from 'react';
import { Route, Routes } from "react-router-dom";
//===---Components
import NavBar from'./javascript/navBar.js';
import About from './javascript/about.js';
import ScrollToTop from './javascript/vitals/scroll.js'
//===--- Pages
import Home from './javascript/home';
import Menu from './javascript/menu';
import Rewards from './javascript/rewards';
import GiftCards from './javascript/giftCards';
import Account from './javascript/account';
import CreateAccount from './javascript/createAccount.js';
import Product from './javascript/product.js';

export default function App(props) {
  const [progress, setProgress] = useState(
    parseInt(localStorage.getItem('progress')) || 0
  );
  useEffect(() => {
    localStorage.setItem('progress', progress);
  }, [progress]);

  const [isSignedIn, setSignedIn] = useState(
    localStorage.getItem('isSignedIn') === 'true'
  );
  useEffect(() => {
    localStorage.setItem('isSignedIn', isSignedIn);
  }, [isSignedIn]);

  const [username, setUsername] = useState(
    localStorage.getItem('username') || ''
  );
  useEffect(() => {
    localStorage.setItem('username', username);
  }, [username]);

  const [screenSize, setScreenSize] = useState(false);
  window.addEventListener('resize', handleResize);
  window.addEventListener('load', handleResize);

  function handleResize() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      setScreenSize(false);
    } else {
      setScreenSize(true);
    }
  }
  
  return (
    <div id='app'>
      <NavBar screenSize={screenSize} isSignedIn={isSignedIn} setSignedIn={setSignedIn} username={username}/>
      <main>
      <ScrollToTop />
        <Routes>
          <Route exact path="/"
          element={<Home screenSize={screenSize} isSignedIn={isSignedIn}/>}
          />
          <Route path="/menu"
          element={<Menu />}
          />
          <Route path="/rewards"
          element={<Rewards isSignedIn={isSignedIn} username={username} progress={progress} setProgress={setProgress}/>}
          />
          <Route path="/gift_cards"
          element={<GiftCards isSignedIn={isSignedIn}/>}
          />
          <Route path="/account"
          element={<Account setSignedIn={setSignedIn}/>}
          />
          <Route path="/create_account"
          element={<CreateAccount setSignedIn={setSignedIn} setUsername={setUsername}/>}
          />
          <Route path="/menu/product"
          element={<Product isSignedIn={isSignedIn} setProgress={setProgress} progress={progress} />}
          />
        </Routes>
      </main>
      <footer>
      <About />
      </footer>
    </div>
  );
}